export const Colors = {
  niceBlue: "#128ED6",
  blueGrey: '#D5E1E5',
  lightGrey: '#C1C1C1',
};
